import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
    //要设置的全局访问的state对象
    const state={
        //要设置的初始属性值
        ress:{
            audoRess:0,
            imgRess:0,
            videoRess:0,
            docRess:0,
            textRess:0,
        },
        lastLeaveTime:0,
        //防止下载的时候弹出‘禁止切浏览器标签’
        isSwitch:false,

        isZip:{
            tempFiles:[],//文件续传，暂时保存文件
            checkpoint:[],//文件上传，保存切片
            zipLoading:{},
            zipError:[],
            uploadID:[],
        }
    };
    //实时监听state值的变化(最新状态)
    const getters = {
        is_audioRess(state) { 
            return state.ress.audoRess
        },
        is_imgRess(state) { 
            return state.ress.imgRess
        },
        is_videoRess(state) { 
            return state.ress.videoRess
        },
        is_textRess(state) { 
            return state.ress.textRess
        },
        is_docRess(state) { 
            return state.ress.docRess
        },
        is_lastLeaveTime(state) { 
            return state.lastLeaveTime
        },
        is_isSwitch(state) { 
            return state.isSwitch
        },
        // 上传zip
        is_isZip_tempFiles(state) {
            return state.isZip.tempFiles
        },
        is_isZip_checkpoint(state) {
            return state.isZip.checkpoint
        },
        is_isZip_zipLoading(state) {
            return state.isZip.zipLoading
        },
        is_isZip_zipError(state) {
            return state.isZip.zipError
        },
        is_isZip_uploadID(state) {
            return state.isZip.uploadID
        }
    };
    const mutations = {
        get_imgRess(state,val){
			state.ress.imgRess = val
        },
        get_audioRess(state,val){
			state.ress.audoRess = val
        },
        get_videoRess(state,val){
			state.ress.videoRess = val
        },
        get_textRess(state,val){
			state.ress.textRess = val
        },
        get_docRess(state,val){
			state.ress.docRess = val
        },
        get_lastLeaveTime(state,val){
			state.lastLeaveTime = val
        },
        get_isSwitch(state,val){
			state.isSwitch = val
        },

        // 上传zip
        get_all_tempFiles(state,val){
            state.isZip.tempFiles = val
        },
        get_all_checkpoint(state,val){
            state.isZip.checkpoint = val
        },
        get_all_zipLoading(state,val){
            state.isZip.zipLoading = val
        },
        get_all_zipError(state,val){
            state.isZip.zipError = val
        },
        get_all_uploadID(state,val){
            state.isZip.uploadID = val
        },
        //直接保存   
        get_add_tempFiles(state,file){
			state.isZip.tempFiles.push(file)
        },
        get_delete_tempFiles(state,data){//data:name 或 serial
            state.isZip.tempFiles.forEach((element,index) => {
                if(data.name && element.name == data.name)
                state.isZip.tempFiles.splice(index, 1)
                else if(data.serial && element.serial == data.serial)
                state.isZip.tempFiles.splice(index, 1)
            });
        },
        get_add_checkpoint(state,data){//data:{fileName,serial,checkpoint}
            if(state.isZip.checkpoint.length>0){
                let fleg = false
                state.isZip.checkpoint.forEach((element,index) => {
                    if(element.name == data.fileName){
                        state.isZip.checkpoint[index].cpt = data.checkpoint
                        fleg = true
                    }
                });
                if(!fleg){
                    state.isZip.checkpoint.push({
                        name:data.fileName,
                        serial:data.serial,
                        cpt:data.checkpoint
                    })
                }
            }else{
                state.isZip.checkpoint.push({
                    name:data.fileName,
                    serial:data.serial,
                    cpt:data.checkpoint
                })
            }
        },
        get_delete_checkpoint(state,data){//data:name 或 serial
            state.isZip.checkpoint.forEach((element,index) => {
                if(data.name && element.name == data.name)
                state.isZip.checkpoint.splice(index, 1)
                else if(data.serial && element.serial == data.serial)
                state.isZip.checkpoint.splice(index, 1)
            });
        },
        get_add_zipLoading(state,data){//data:{serial,value}
            state.isZip.zipLoading[`doc_${data.serial}`] = data.value
        },
        get_delete_zipLoading(state,serial){
            delete state.isZip.zipLoading[`doc_${serial}`];
        },
        get_add_zipError(state,data){//data:{serial,callback}
            // state.isZip.zipError[`err_${serial}`] = serial
            state.isZip.zipError.push(data)
        },
        get_delete_zipError(state,serial){
            // delete state.isZip.zipError[`err_${serial}`];
            state.isZip.zipError.forEach((element,index) => {
                if(element.serial == serial)
                state.isZip.zipError.splice(index, 1)
            })
        },
        get_add_uploadID(state,data){
            state.isZip.uploadID.push(data)
        },
        get_delete_uploadID(state,serial){
            state.isZip.uploadID.forEach((element,index) => {
                if(element.serial == serial)
                state.isZip.uploadID.splice(index, 1)
            })
        },
        // 清空zip
        get_deleteAllZip(state){
            state.isZip.tempFiles = []
            state.isZip.checkpoint = []
            state.isZip.zipLoading = {}
            state.isZip.zipError = []
            state.isZip.uploadID = []
        }
    };
    //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    const actions = {
        
    };
    const userStore = new Vuex.Store({
        state,
        getters,
        mutations,
        actions
    });
export default userStore;



// WEBPACK FOOTER //
// ./src/vuex/store.js